import { ApiPortfolioStatus } from '@/api'

import { PortfolioApprovalStatus, PortfolioApprovalTagContent } from '../constants'

export const calculateApprovalTagContent = (approvalStatus: ApiPortfolioStatus) => {
  const result = { color: '', text: '' as PortfolioApprovalTagContent }

  if (approvalStatus === PortfolioApprovalStatus.PENDING_EDIT) {
    result.text = PortfolioApprovalTagContent.EDITS_PENDING_APPROVAL
    result.color = 'var(--Warn)'
  } else if (approvalStatus === PortfolioApprovalStatus.PENDING_NEW) {
    result.text = PortfolioApprovalTagContent.PENDING_APPROVAL
    result.color = 'var(--Warn)'
  } else if (approvalStatus === PortfolioApprovalStatus.REJECTED_EDIT) {
    result.text = PortfolioApprovalTagContent.EDITS_REJECTED
    result.color = 'var(--Error)'
  } else if (approvalStatus === PortfolioApprovalStatus.REJECTED_NEW) {
    result.text = PortfolioApprovalTagContent.NEW_REJECTED
    result.color = 'var(--Error)'
  }

  return result
}
